import API, { defaultHeaders, IRI } from './index';

const fetchVerifyCode = code => {
  const headers = Object.assign({}, defaultHeaders);
  return fetch(`${API}${IRI.courseByCode}${code}`, { headers });
};

export default fetchVerifyCode;
